<script>
    import ChartsReportMixin from './ChartsReportMixin.vue';

    export default {
        name: 'SalesReport',
        mixins: [ChartsReportMixin],
        data() {
            return {
                requests: {
                    amount: this.$req('space/CategorySalesAmountReport'),
                    quantity: this.$req('space/CategoryQuantityReport'),
                },
                currentChart: 'amount',
            };
        },
        computed: {
            header() {
                return this.$t('sales');
            },
        },
        methods: {
            resetFilters() {
                ChartsReportMixin.methods.resetFilters.bind(this)();
                this.currentChart = 'amount';
            },
        },
        created() {
            this.parentComponent.$on('resetFilters', this.resetFilters);
        },
        beforeDestroy() {
            this.parentComponent.$off('resetFilters', this.resetFilters);
        },
    };
</script>
